module.exports = __webpack_public_path__ + "static/Icons_House_active-cc9888060c84552840ef9b7438d85cdc.png";